import React, { useState, useEffect, useCallback } from "react";
import { GoogleMap, useJsApiLoader, Marker, MarkerClusterer, InfoWindow } from "@react-google-maps/api";
import { v4 as uuidv4 } from "uuid";
import MapPin from "../../assets/images/map/MapPin2.svg";
import ClusterIcon from "../../assets/images/map/m6.svg";
import "./location-map.scss";

const containerStyle = {
  width: "100%",
  height: "calc(100vh - 400px)"
};

function LocationMap(props) {
  // const center = {
  //   lat: -3.745,
  //   lng: -38.523
  // };
  const OPTIONS = {
    minZoom: 2,
    maxZoom: 18,
    mapTypeControl: false,
    streetViewControl: false
  };

  const { node, geolocations, googleMapApiKey } = props;
  const [map, setMap] = useState(null);
  const [zoom, setZoom] = useState(2);
  const [geolocationsState, setGeoLocationsState] = useState([]);
  const [infoWindowContent, setInfoWindowContent] = useState(null);
  const [infoWindowPosition, setInfoWindowPosition] = useState(null);
  const [center, setCenter] = useState({
    lat: -3.745,
    lng: -38.523
  });

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: atob(googleMapApiKey),
    libraries: ["places"]
  });

  const getFilteredGeoLocations = (geoLocationData) => {
    let coordData = null;
    // filter campuses from geolocations
    const allCampuses = geoLocationData.filter((e) => {
      return (
        e.inferredLocationTypes.indexOf("CAMPUS") > -1 ||
        e.inferredLocationTypes.indexOf("NETWORK") > -1 ||
        e.inferredLocationTypes.indexOf("ORG") > -1 ||
        e.inferredLocationTypes.indexOf("CMX") > -1 ||
        e.inferredLocationTypes.indexOf("WLC") > -1
      );
    });

    if (allCampuses && allCampuses.length) {
      coordData = allCampuses;
    } else {
      const allBuildings = geoLocationData.filter((e) => {
        return e.inferredLocationTypes.indexOf("BUILDING") > -1;
      });
      const allOutdoorLocations = geoLocationData.filter((e) => {
        return e.inferredLocationTypes.indexOf("OUTDOOR_AREA") > -1;
      });
      if (allBuildings && allBuildings.length) {
        coordData = allBuildings;
      } else if (allOutdoorLocations && allOutdoorLocations.length) {
        coordData = allOutdoorLocations;
      } else {
        const allFloors = geoLocationData.filter((e) => {
          return e.inferredLocationTypes.indexOf("FLOOR") > -1;
        });
        if (allFloors && allFloors.length) {
          coordData = allFloors;
        } else {
          coordData = null;
        }
      }
    }
    return coordData;
  };

  const getChildrenMapLocations = (fmap) => {
    if (node && node.data && node.data.id && geolocations && geolocations.coordinatesData && geolocations.coordinatesData.length) {
      let coordData = null;
      const selectedNodeId = node.data.id;
      const geoLocationData = geolocations.coordinatesData;
      console.log("Geo Locations::", geoLocationData);
      if (node.data.type[0]) {
        if (node.data.type[0] === "ROOT") {
          coordData = getFilteredGeoLocations(geoLocationData);
        } else {
          // filter campuses from geolocations
          const allChildren = geoLocationData.filter((e) => {
            return e.locationPath.indexOf(selectedNodeId) > -1;
          });
          coordData = getFilteredGeoLocations(allChildren);
        }
        if (coordData && coordData.length) {
          setGeoLocationsState(coordData);
          const bounds = new window.google.maps.LatLngBounds();
          if (coordData.length === 1) {
            // Add your marker coordinates here
            const markerPosition = { lat: coordData[0].latitude, lng: coordData[0].longitude };
            setCenter(markerPosition);
            bounds.extend(markerPosition);
            fmap.fitBounds(bounds); // Automatically zoom to fit the marker
            setMap(fmap);
            setZoom(16);
          } else {
            coordData.forEach((cdata) => {
              const markerPosition = { lat: cdata.latitude, lng: cdata.longitude };
              bounds.extend(markerPosition);
            });
            fmap.fitBounds(bounds); // Automatically zoom to fit the marker
            setMap(fmap);
            // setZoom(16);
          }
        } else {
          setGeoLocationsState([]);
          setZoom(2);
          setMap(fmap);
        }
        console.log("Updated CoordData::", coordData);
      }
    }
  };

  useEffect(() => {
    // setTimeout(() => {
    //   setZoom(2);
    // }, 300);
    // if(geolocations) {
    //     console.log('geolocations.coordinatesData', geolocations.coordinatesData)
    //     setGeoLocations(geolocations.coordinatesData)
    // }
    console.log("Selected node", map, node, geolocations);
  }, []);

  const onLoad = useCallback(function callback(fmap) {
    // setTimeout(() => {
    //   setZoom(2);
    // }, 300);
    // console.log(fmap);
    // const { geolocations } = props;
    // if (geolocations) {
    //   const { coordinatesData } = geolocations;
    //   console.log("coordinatesData", coordinatesData);
    //   setGeoLocationsState(coordinatesData);
    // }
    getChildrenMapLocations(fmap);
  }, []);

  const onUnmount = useCallback(function callback(fmap) {
    console.log(fmap);
    setMap(null);
  }, []);

  const mcOptions = {
    styles: [
      {
        url: ClusterIcon,
        width: 37,
        height: 37,
        fontFamily: "Inter, sans-serif",
        fontWeight: "normal",
        textSize: 14,
        textColor: "#ffffff"
      },
      {
        url: ClusterIcon,
        width: 37,
        height: 37,
        fontFamily: "Inter, sans-serif",
        fontWeight: "normal",
        textSize: 14,
        textColor: "#ffffff"
      },
      {
        url: ClusterIcon,
        width: 37,
        height: 37,
        fontFamily: "Inter, sans-serif",
        fontWeight: "normal",
        textSize: 14,
        textColor: "#ffffff"
      },
      {
        url: ClusterIcon,
        width: 37,
        height: 37,
        fontFamily: "Inter, sans-serif",
        fontWeight: "normal",
        textSize: 14,
        textColor: "#ffffff"
      },
      {
        url: ClusterIcon,
        width: 37,
        height: 37,
        fontFamily: "Inter, sans-serif",
        fontWeight: "normal",
        textSize: 14,
        textColor: "#ffffff"
      }
    ]
  };

  const getPosition = (geolocation) => {
    return {
      lat: geolocation.latitude,
      lng: geolocation.longitude
    };
  };

  const handleMouseClick = (location) => {
    setInfoWindowPosition(getPosition(location));
    setInfoWindowContent(location);
  };

  const handleMouseOut = () => {
    setInfoWindowContent(null);
    setInfoWindowPosition(null);
  };

  return isLoaded && geolocationsState ? (
    <GoogleMap mapContainerStyle={containerStyle} zoom={zoom} center={center} options={OPTIONS} onLoad={onLoad} onUnmount={onUnmount}>
      <MarkerClusterer styles={mcOptions.styles}>
        {(clusterer) =>
          geolocationsState.map((geolocation) => <Marker onClick={() => handleMouseClick(geolocation)} key={uuidv4()} position={getPosition(geolocation)} icon={MapPin} clusterer={clusterer} />)
        }
      </MarkerClusterer>
      {infoWindowContent && infoWindowPosition?.lat && infoWindowPosition.lng && (
        <InfoWindow
          options={{ maxWidth: 440, minWidth: 440 }} // Set maximum width
          style={{ backgroundColor: "white", padding: "10px", borderRadius: "5px" }}
          position={{ lat: infoWindowPosition.lat, lng: infoWindowPosition.lng }}
          onCloseClick={handleMouseOut}
        >
          <div className="lhMapMarker">
            <div className="lhmHeader">
              <div className="lhmName">{infoWindowContent.name}</div>
              <div className="lhmAddress">{infoWindowContent.address}</div>
            </div>
            <div className="lhmContent">
              <div>
                <div className="lhmSubheading lhm1">Total Area &#40; {infoWindowContent.totalAreaUnit ? infoWindowContent.totalAreaUnit : "Sq. Ft"} &#41;</div>
                <div className="lhmSubvalue">{infoWindowContent.totalArea ? infoWindowContent.totalArea : "NA"}</div>
              </div>
              <div>
                <div className="lhmSubheading lhm2">Max Capacity</div>
                <div className="lhmSubvalue">{infoWindowContent.totalCapacity ? infoWindowContent.totalCapacity : "NA"}</div>
              </div>
              <div>
                <div className="lhmSubheading lhm3">Timezone</div>
                <div className="lhmSubvalue">{infoWindowContent.inferredTimeZoneId ? infoWindowContent.inferredTimeZoneId : "NA"}</div>
              </div>
            </div>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  ) : (
    ""
  );
}

export default React.memo(LocationMap);
